import { translate } from "app/filters/i18nFilter";
import PanelSubmitButton from "app/pages/sales-intelligence/common-components/table-actions-panel/components/PanelSubmitButton/PanelSubmitButton";

type RemoveSubmitButtonProps = {
    className?: string;
    disabledTooltipContent?: string;
    isDisabled?: boolean;
    isLoading?: boolean;
    tooltipContent?: string;
    onClick(): void;
};

const RemoveSubmitButton = (props: RemoveSubmitButtonProps) => {
    const {
        disabledTooltipContent = translate("si.multi_selector.tooltip.remove.unselected_domains"),
        tooltipContent = "",
        ...rest
    } = props;
    const currentTooltipContent = rest.isDisabled ? disabledTooltipContent : tooltipContent;

    return (
        <PanelSubmitButton
            {...rest}
            text={translate("si.multi_selector.button.remove.label")}
            tooltipContent={currentTooltipContent}
        />
    );
};

export default RemoveSubmitButton;
